export const getUntil = (s, delim) => {
    s = s.toString()
    const i = s.indexOf(delim)
    return (i !== -1) ? s.substr(0, i) : s
}

export default {
    methods: {getUntil}
}
